import styled from 'styled-components';
import { container, flexPosition, fontStyle } from '../../styles/mixins';
import { GRAY_DARKER, FONT_WEIGHT_BOLD, FONT_SIZE_6 } from '../../styles/variables';

export const Container = styled.div``;

export const Content = styled.div`
  ${container()}
  ${flexPosition({ align: 'center', justify: 'space-between' })}
`;

export const Header = styled.div`
  background-color: #fff;
  ${flexPosition({ align: 'center', justify: 'space-between' })}
  width: 100%;
  height: 115px;
`;

export const RightInfo = styled.div``;

export const ServiceTypes = styled.div`
  ${flexPosition({ align: 'center' })}
  margin-bottom: 15px;
`;

export const Service = styled.div`
  ${flexPosition({ align: 'center', justify: 'flex-end' })}
  ${fontStyle(GRAY_DARKER, FONT_SIZE_6, FONT_WEIGHT_BOLD)}
  margin-right: 30px;
  width: max-content;
  &:last-child {
    margin-right: 0;
  }
`;

export const Icon = styled.img`
  width: 30px;
  margin-right: 5px;
`;

export const Body = styled.div``;

export const Box = styled.div`
  ${flexPosition({ align: 'center', justify: 'space-between' })}
  width: 100%;
  padding: 30px;
  margin-top: 35px;
  margin-bottom: 120px;
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.05);
`;

export const Form = styled.form``;

export const RadioContainer = styled.div`
  ${flexPosition({ align: 'center', justify: 'space-between' })}
`;

export const BoxInline = styled.div`
  ${flexPosition({ align: 'top', justify: 'space-between' })}
  ${Box} {
    margin-right: 30px;
    height: 400px;
    padding: 30px 15px;
    &:last-child {
      margin-right: 0;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/screens/SelectProducts/style.js